import { ADD } from "@crispico/foundation-react";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { IGanttActionParam, IGanttActionParamForRun } from "@crispico/react-timeline-10000";
import { IActionParam } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { AbstractAction, AbstractActionLocalState, AbstractActionProps } from "components/ContextMenuRegistry";
import moment from "moment-timezone";

export class CreateMissionAction extends AbstractAction<AbstractActionProps, AbstractActionLocalState> {

    icon = "list alternate outline";
    label: string | ((param: IActionParam) => string) = _msg("CreateMissionAction.label");

    protected getSearchParams(id: string | number, entityName: string, startTime: number): string {
        const entity = this.props.getEntityAt(id);
        if (!entity) {
            return '';
        }
        const params = new URLSearchParams();
        params.set(`startTime`, moment(startTime).toISOString());
        params.set(`endTime`, moment(startTime).add(1, 'h').toISOString());

        switch (entityName) {
            case "EquipmentResource":
                params.set("equipmentResource", JSON.stringify(entity));
                entity.equipmentType && params.set("equipmentType", JSON.stringify(entity.equipmentType));
                break;
            case "HumanResourceSchedule":
                entity.humanResource && params.set("humanResource", JSON.stringify(entity.humanResource));
                entity.humanResource && entity.humanResource.equipmentResource && params.set("equipmentResource", JSON.stringify(entity.humanResource.equipmentResource));
                break;
        }

        return params.toString();
    }

    private getActionTarget(param: IGanttActionParam): { key: string | number; entityName: string } | null {
        let key: string | number;
        let entityName: string;

        if (param.selection.length === 1) {
            key = param.selection[0];
            entityName = this.getEntityName(key);
        } else if (param.selection.length === 0) {
            if (param.row === undefined || !this.props.getEntityAt(param.row)) {
                return null;
            }
            key = param.row;
            entityName = this.getEntityName(this.props.getEntityUid(key));
        } else {
            return null;
        }
        return { key, entityName };
    }

    isVisible(param: IGanttActionParam) {
        const target = this.getActionTarget(param);
        if (!target) {
            return false;
        }

        return target.entityName === "EquipmentResource" || target.entityName === "HumanResourceSchedule";
    }

    async run(param: IGanttActionParamForRun) {
        const target = this.getActionTarget(param);
        if (!target) {
            // This case should ideally not be reached if isVisible is respected,
            // but it's a good safeguard.
            return;
        }
        const { key, entityName } = target;

        const searchParams = this.getSearchParams(key, entityName, moment(param.time).valueOf());
        AppMetaTempGlobals.history.push(entityDescriptors["Mission2"].getEntityEditorUrl(ADD) + "/edit?" + searchParams);
    }
}
